import { render, staticRenderFns } from "./TradesOverviewStats.vue?vue&type=template&id=e4bfa0c8&"
import script from "./TradesOverviewStats.vue?vue&type=script&lang=js&"
export * from "./TradesOverviewStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports